import React from 'react'

import Experiment from '@mc/experiments-react'

import { BOGO_OFFER_VARIABLES_FLAG_NAME } from '../../constants'
import { InnerUrgency, InnerUrgencyProps } from './InnerUrgency'

type UrgencyHandlerProps = Omit<InnerUrgencyProps, 'variables'> & {
  flagName?: string
}

export const UrgencyHandler = ({
  children,
  config,
  flagName = BOGO_OFFER_VARIABLES_FLAG_NAME,
}: UrgencyHandlerProps) => (
  <Experiment
    name={flagName}
    default={(props: Omit<InnerUrgencyProps, 'children' | 'variables'>) => (
      <InnerUrgency {...props}>{children}</InnerUrgency>
    )}
    lazyload={false}
    config={config}
  />
)
